// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontHeading_46444d', '__fontHeading_Fallback_46444d'"},"className":"__className_46444d","variable":"__variable_46444d"};